import { CONTENT_SCHEMA } from './contentSchema';

export function PropertyEditor({ element, onChange }) {
  if (!element) {
    return (
      <div style={panelStyle}>
        <h3>No selection</h3>
        <p>Select an element to edit properties</p>
      </div>
    );
  }

  const schema = CONTENT_SCHEMA[element.type];
  if (!schema) return null;

  const content = element.content || {};

  return (
    <div style={panelStyle}>
      <h3>{element.type.toUpperCase()} CONTENT</h3>

      {Object.entries(schema).map(([key, config]) => (
        <PropertyField
          key={key}
          label={config.label}
          type={config.type}
          value={content[key] ?? ''}
          onChange={(v) => onChange({ [key]: v })}
        />
      ))}
    </div>
  );
}

function PropertyField({ label, type, value, onChange }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={labelStyle}>{label}</label>

      {type === 'text' && (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      {type === 'textarea' && (
        <textarea
          value={value}
          rows={4}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  );
}


const panelStyle = {
  // width: 280, <-- REMOVE THIS
  padding: 16,
  // borderLeft: '1px solid #ddd', <-- REMOVE THIS
  background: 'transparent', // Let the sidebar handle the background
  boxSizing: 'border-box',
  flexShrink: 0, // Prevents the top editor from being squashed
};
const labelStyle = {
  display: 'block',
  fontSize: 12,
  opacity: 0.7,
  marginBottom: 4,
};
